import { Box } from '@mui/system'
import React from 'react'
import { backgroundColors } from '../Components/Common/Color/Color'
import Feedback from '../Components/Feedback'

const FeedbackPage: React.FC = () => {
  return (
    <Box
      component='div'
      sx={{
        p: 2,
        backgroundColor: backgroundColors.white,
        width: 'auto',
        borderRadius: 2,
        boxShadow: 1,
      }}
    >
      <Feedback />
    </Box>
  )
}

export default FeedbackPage
